import ZoomMeeting from './container';

export default ZoomMeeting;



// WEBPACK FOOTER //
// ./src/routes/ZoomMeeting/index.js